import React, { useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";

import TableWidget from "../../../../components/tables/TableWidget";

import { postCollectionErrorsDetailed } from "../../../../redux/api/reports.api";
import { TableActions } from "../../../../components/tables/tableContext/TableContext";
import CollectionErrorsDropdwonsHeader from "../CollectionErrrorsSimplified/components/CollectionErrorsDropdwonsHeader";
import {
  collectionErrorsDetailedTableHeader,
  getCollectionErrorsDetailedTableData,
} from "./tableConfigs/collectionErrorsDetailedTableConfig";

const DetailedHeader = () => (
  <CollectionErrorsDropdwonsHeader reportType="detailed" />
);

function CollectionErrorsDetailed() {
  const dispatch = useAppDispatch();

  const {
    reports: {
      collectionErrorsDetailed: {
        data: { data: collectionErrorsDetailed, total },
        isLoading,
      },
    },
  } = useAppSelector((state) => ({
    reports: state.reports,
  }));

  const tableItems = useMemo(
    () => getCollectionErrorsDetailedTableData(collectionErrorsDetailed),
    [collectionErrorsDetailed],
  );

  const handleTableActions = (action: TableActions) => {
    if (
      action.tablePagination.page &&
      action.tablePagination.rowsPerPage &&
      action.tableSearch
    ) {
      if (
        action.tableSearch.selectedMonth &&
        action.tableSearch.selectedYear &&
        action.tableSearch.selectedUsers
      ) {
        dispatch(
          postCollectionErrorsDetailed({
            page: action.tablePagination.page,
            per_page: action.tablePagination.rowsPerPage,
            selectedUsers: JSON.parse(action.tableSearch.selectedUsers),
            month: action.tableSearch.selectedMonth,
            year: action.tableSearch.selectedYear,
            day: parseInt(action.tableSearch.selectedDay),
          }),
        );
      }
    }
  };

  return (
    <TableWidget
      tableHeaderData={collectionErrorsDetailedTableHeader}
      tableItemsData={tableItems}
      handleTableActions={handleTableActions}
      CustomHeaderComponent={DetailedHeader}
      totalItems={total}
      tableLoading={isLoading}
      withGlobalSearch={false}
      withGlobalFilter={false}
    />
  );
}

export default CollectionErrorsDetailed;
